import { render, staticRenderFns } from "./TransferenciaPosseDefinitivaPasso2.vue?vue&type=template&id=e82c66ec&lang=html&"
import script from "./TransferenciaPosseDefinitivaPasso2.vue?vue&type=script&lang=js&"
export * from "./TransferenciaPosseDefinitivaPasso2.vue?vue&type=script&lang=js&"
import style0 from "./TransferenciaPosseDefinitivaPasso2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/transferencia-posse/definitiva/TransferenciaPosseDefinitivaPasso2.vue
// module id = 1583
// module chunks = 28